/** @format */

const url = "https://frozen-hollows-01712.herokuapp.com";

module.exports = url;
